export enum JobSet {
	SCHEDULED = 'scheduled',
	JOB_RUN = 'job_run',
	OPTIONAL = 'optional'
}
